import axios from 'axios';
import { SignInRequest } from '../models/request/signInRequest';
import { SignInResponse } from '../models/response/signInResponse'; 
import EndPoints from '../constants/endPoints';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ALMOWAZI_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});  

const signIn = async (credentials: SignInRequest): Promise<SignInResponse> => { 
  try { 
    const response = await axiosInstance.post(EndPoints.Auth.SignIn, credentials);
    const responseData = response.data as SignInResponse;
    if (responseData.token) {
      localStorage.setItem('token', responseData.token);
    }
    return responseData;
  } catch (error) {
    throw new Error('Failed to sign in');
  }
};

const forgotPassword = async (email: string): Promise<any> => { 
  try { 
    const response = await axiosInstance.post( 
      `${EndPoints.Auth.ForgotPassword}?email=${email}`,
    ); 
    return response;
  } catch (error) {
    throw new Error('Failed to sign in');
  }
};

const changePassword = async (id: string, password: string): Promise<any> => { 
  try { 
    const encodedPassword = encodeURIComponent(password); 
    const response = await axiosInstance.post(
      `${EndPoints.Auth.ChangePassword}?id=${id}&password=${encodedPassword}`
    ); 
    return response;
  } catch (error) {
    throw new Error('Failed to change password');
  }
};

const signInInvestor = async (credentials: SignInRequest): Promise<SignInResponse> => { 
  try { 
    const response = await axiosInstance.post(EndPoints.Auth.SignInInvestor, credentials);
    const responseData = response.data as SignInResponse; 
    return responseData;
  } catch (error) {
    throw new Error('Failed to sign in');
  }
};

const verifyCode = async (code: string, email:string): Promise<any> => { 
  try {   
    const response = await axiosInstance.post(
      `${EndPoints.Auth.VerifyCode}?email=${email}&code=${code}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error('Failed to sign in');
  }
};

const logout = () => {
  localStorage.removeItem("token");
};

export const authService = {
  signIn,
  forgotPassword,
  changePassword,
  signInInvestor,
  verifyCode,
  logout
};
